<template>
    <div class="ip-blacklist">
        <el-card class="content-card" shadow="never">
            <template #header>
                <div class="card-header">
                    <div class="header-title">
                        <el-icon>
                            <CircleClose />
                        </el-icon>
                        <span>IP 黑名单管理</span>
                    </div>
                    <el-button type="danger" @click="showAddDialog">
                        <el-icon>
                            <Plus />
                        </el-icon> 手动拉黑 IP
                    </el-button>
                </div>
            </template>

            <el-table :data="blacklist" v-loading="loading" style="width: 100%">
                <el-table-column prop="ip" label="IP 地址" width="180" />
                <el-table-column prop="reason" label="拉黑原因" min-width="200" />
                <el-table-column prop="expiresAt" label="过期时间" width="180">
                    <template #default="scope">
                        {{ scope.row.expiresAt ? formatDate(scope.row.expiresAt) : '永久有效' }}
                    </template>
                </el-table-column>
                <el-table-column prop="createdAt" label="拉黑时间" width="180">
                    <template #default="scope">
                        {{ formatDate(scope.row.createdAt) }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120" fixed="right">
                    <template #default="scope">
                        <el-button link type="primary" @click="removeIP(scope.row)">解除锁定</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- Add Dialog -->
        <el-dialog v-model="dialogVisible" title="手动拉黑 IP" width="400px">
            <el-form :model="form" label-position="top">
                <el-form-item label="IP 地址">
                    <el-input v-model="form.ip" placeholder="例如: 192.168.1.1" />
                </el-form-item>
                <el-form-item label="拉黑原因">
                    <el-input v-model="form.reason" placeholder="请输入拉黑原因" />
                </el-form-item>
                <el-form-item label="持续时间 (小时, 0为永久)">
                    <el-input-number v-model="form.duration" :min="0" style="width: 100%" />
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="danger" @click="addIP" :loading="submitting">确定拉黑</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { CircleClose, Plus } from '@element-plus/icons-vue'
import api from '@/utils/api'
import dayjs from 'dayjs'

const blacklist = ref([])
const loading = ref(false)
const dialogVisible = ref(false)
const submitting = ref(false)

const form = ref({
    ip: '',
    reason: '',
    duration: 24
})

const formatDate = (date) => {
    return dayjs(date).format('YYYY-MM-DD HH:mm')
}

const loadBlacklist = async () => {
    loading.value = true
    try {
        const res = await api.get('/api/admin/ip-blacklist')
        blacklist.value = res.data.list || []
    } catch (error) {
        ElMessage.error('加载黑名单失败')
    } finally {
        loading.value = false
    }
}

const showAddDialog = () => {
    form.value = { ip: '', reason: '', duration: 24 }
    dialogVisible.value = true
}

const addIP = async () => {
    if (!form.value.ip) return ElMessage.warning('请输入 IP')
    submitting.value = true
    try {
        await api.post('/api/admin/ip-blacklist', form.value)
        ElMessage.success('添加成功')
        dialogVisible.value = false
        loadBlacklist()
    } catch (error) {
        ElMessage.error('添加失败')
    } finally {
        submitting.value = false
    }
}

const removeIP = (row) => {
    ElMessageBox.confirm(`确定解除对 IP ${row.ip} 的锁定吗？`, '提示', {
        type: 'warning'
    }).then(async () => {
        try {
            await api.delete(`/api/admin/ip-blacklist/${row.id}`)
            ElMessage.success('已解除锁定')
            loadBlacklist()
        } catch (error) {
            ElMessage.error('操作失败')
        }
    })
}

onMounted(loadBlacklist)
</script>

<style scoped>
.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 600;
}

.content-card {
    border: none;
    border-radius: 12px;
}
</style>
